export function activateKeepAwake() {
  // nothing
}

export function deactivateKeepAwake() {
  // nothing
}
